/**
 * “As Seen On” press logos for the homepage strip. Assets live in
 * `public/marketing/press/<slug>.svg` as reverse (light-on-dark) variants —
 * the marketing surface is always the dark page gradient.
 *
 * `width` / `height` are the asset's intrinsic viewBox dimensions; the strip
 * renders every logo at a shared token height and lets width follow the ratio,
 * so optically-heavier marks stay balanced without per-logo CSS.
 */
export type PressLogo = {
  slug: string
  /** Outlet name — used as the accessible label. */
  name: string
  width: number
  height: number
}

export const homePressLogos: PressLogo[] = [
  { slug: 'cnbc', name: 'CNBC', width: 384, height: 124 },
]
